/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Request to grant an entitlement to a tenant
 * @export
 * @interface GrantEntitlementRequest
 */
export interface GrantEntitlementRequest {
    /**
     * Tenant ID
     * @type {string}
     * @memberof GrantEntitlementRequest
     */
    tenantId: string;
    /**
     * Feature ID
     * @type {string}
     * @memberof GrantEntitlementRequest
     */
    featureId: string;
    /**
     * Source: BUNDLE, ADDON, TRIAL, MANUAL_GRANT, EARLY_ACCESS
     * @type {string}
     * @memberof GrantEntitlementRequest
     */
    source?: string;
    /**
     * Principal who granted (e.g. email). If omitted, set from session when available.
     * @type {string}
     * @memberof GrantEntitlementRequest
     */
    grantedBy?: string;
    /**
     * Quantity (seats or units)
     * @type {number}
     * @memberof GrantEntitlementRequest
     */
    quantity?: number;
    /**
     * Quantity limit (null = unlimited)
     * @type {number}
     * @memberof GrantEntitlementRequest
     */
    quantityLimit?: number;
    /**
     * Effective from (ISO-8601). Defaults to now.
     * @type {Date}
     * @memberof GrantEntitlementRequest
     */
    effectiveFrom?: Date;
    /**
     * Effective to (ISO-8601). Null = no expiry.
     * @type {Date}
     * @memberof GrantEntitlementRequest
     */
    effectiveTo?: Date;
    /**
     * Optional commercial or ops reason (e.g. when granting entitlement_distributor; stored in audit business context).
     * @type {string}
     * @memberof GrantEntitlementRequest
     */
    reason?: string;
}

/**
 * Check if a given object implements the GrantEntitlementRequest interface.
 */
export function instanceOfGrantEntitlementRequest(value: object): value is GrantEntitlementRequest {
    if (!('tenantId' in value) || value['tenantId'] === undefined) return false;
    if (!('featureId' in value) || value['featureId'] === undefined) return false;
    return true;
}

export function GrantEntitlementRequestFromJSON(json: any): GrantEntitlementRequest {
    return GrantEntitlementRequestFromJSONTyped(json, false);
}

export function GrantEntitlementRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): GrantEntitlementRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'tenantId': json['tenantId'],
        'featureId': json['featureId'],
        'source': json['source'] == null ? undefined : json['source'],
        'grantedBy': json['grantedBy'] == null ? undefined : json['grantedBy'],
        'quantity': json['quantity'] == null ? undefined : json['quantity'],
        'quantityLimit': json['quantityLimit'] == null ? undefined : json['quantityLimit'],
        'effectiveFrom': json['effectiveFrom'] == null ? undefined : (new Date(json['effectiveFrom'])),
        'effectiveTo': json['effectiveTo'] == null ? undefined : (new Date(json['effectiveTo'])),
        'reason': json['reason'] == null ? undefined : json['reason'],
    };
}

export function GrantEntitlementRequestToJSON(json: any): GrantEntitlementRequest {
    return GrantEntitlementRequestToJSONTyped(json, false);
}

export function GrantEntitlementRequestToJSONTyped(value?: GrantEntitlementRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'tenantId': value['tenantId'],
        'featureId': value['featureId'],
        'source': value['source'],
        'grantedBy': value['grantedBy'],
        'quantity': value['quantity'],
        'quantityLimit': value['quantityLimit'],
        'effectiveFrom': value['effectiveFrom'] == null ? undefined : ((value['effectiveFrom']).toISOString()),
        'effectiveTo': value['effectiveTo'] == null ? undefined : ((value['effectiveTo']).toISOString()),
        'reason': value['reason'],
    };
}

